var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 318,
    viewBox: "0 0 424 318",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M333.483 293.927C279.785 293.927 171.155 293.377 163.383 293.377L156.098 221.065L182.812 173.128L196.978 158.503L213.169 165.003L241.597 151.236C251.226 146.574 262.795 150.938 266.945 160.799L279.144 189.784L311.929 158.503C324.921 146.467 333.372 141.797 338.771 141.535C359.39 140.534 343.155 177.536 336.19 196.969L329.739 214.971C358.234 195.796 362.524 195.885 368.191 194.253C403.162 184.178 358.983 256.958 333.483 293.927Z",
    fill: "url(#paint0_linear_7092_74372)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6588 292.623C86.4726 292.623 179.154 292.248 185.784 292.248L192 242.902L169.208 210.19L157.122 200.21L143.308 204.645L119.459 195.408C110.615 191.983 100.608 195.732 96.1913 204.125L87.0195 221.556L59.0477 200.21C54.9314 197.159 51.3493 194.802 48.2364 193.035C27.8379 181.456 34.2622 217.339 43.8532 238.744C19.5419 225.659 15.8814 225.719 11.0468 224.605C-18.7898 217.73 18.9029 267.396 40.6588 292.623Z",
    fill: "url(#paint1_linear_7092_74372)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 293.477H423",
    stroke: "#383751",
    strokeWidth: 1.09836,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.441 45.8625C144.619 46.2008 149.092 42.277 149.43 37.0983C149.768 31.9196 145.845 27.4471 140.666 27.1088C135.487 26.7704 131.015 30.6943 130.676 35.873C130.338 41.0517 134.262 45.5241 139.441 45.8625Z",
    fill: "#FFDC83"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.257 50.9619C149.5 48.6229 149.572 46.9588 148.427 45.3021C147.272 43.6448 145.707 42.2579 144.882 40.4099C144.14 38.7689 144.05 36.9051 144.093 35.1031C144.175 31.0848 144.832 27.0509 144.371 23.0502C143.911 19.0496 142.079 14.9168 138.517 13.0385L129.834 57.3792C138.5 57.3792 152 57.1229 155 57.3792C153 50.952 152 51.6229 149.268 50.952L149.257 50.9619Z",
    fill: "#000E39"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.71 56.6523L129.943 74.884L108.97 74.002L109.535 43.4102L130.71 56.6523Z",
    fill: "#FFB796"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143.455 22.7786C143.534 23.1873 143.9 40.9939 143.21 45.2167C142.531 49.4296 138.561 56.4106 130.297 56.6351C120.332 56.9076 108.881 44.1628 108.881 44.1628L110.057 16.4136C110.057 16.4136 115.791 6.64943 127.664 7.24469C139.536 7.85053 143.456 22.7681 143.456 22.7681L143.455 22.7786Z",
    fill: "#FFB796"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.779 34.4266C111.764 32.2173 108.415 30.6714 106.222 30.4326C104.029 30.1938 101.808 31.535 100.809 33.4975C99.8103 35.46 99.958 37.9115 100.999 39.8586C102.039 41.8057 103.877 43.2528 105.938 44.0457C107.999 44.8386 110.26 44.997 112.452 44.7686L111.779 34.4266Z",
    fill: "#FFB08B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M116.089 50.3457C116.089 50.3457 117.287 59.7984 130.528 61.0564L130.712 56.62C128.082 56.5756 122.004 55.3504 116.089 50.3457Z",
    fill: "#FFA378"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.71 7.03296C126.999 1.81869 116.107 1.16012 110.059 5.9777C107.887 7.70428 105.368 9.20651 103.967 12.4592C103.967 12.4592 102.831 11.8011 97.9288 16.152C94.0061 19.6434 94.5598 25.3063 94.5598 25.3063C94.5598 25.3063 90.1132 25.9288 87.0811 29.765C84.9628 32.4506 84.3386 38.4294 85.0223 41.7758C76.4997 43.6235 75.2165 52.549 76.4995 57.1236L110.059 57.1236C109.486 46.0767 112.195 36.6611 111.188 26.0848C118.268 20.4111 127.848 18.3935 132.71 7.03296Z",
    fill: "#000E39"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.226 37.4312C113.529 42.5771 108.802 46.1858 103.656 45.4886C98.5103 44.7914 94.9016 40.0649 95.5988 34.9189C96.296 29.773 101.023 26.1643 106.169 26.8615C111.314 27.5587 114.923 32.2853 114.226 37.4312Z",
    fill: "#FFDC83"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M101.857 32.0784C101.857 32.0784 92.5249 10.6284 110.059 5.97745C110.059 5.97745 104.31 8.82923 104.432 16.2263C104.554 23.6234 107.005 32.0857 107.005 32.0857L101.857 32.0784Z",
    fill: "#FFDC83"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M128.423 5.53248C128.385 5.79539 139.968 18.7825 144.466 24.2042C144.466 24.2042 145.746 15.1682 141.664 10.2195C135.23 2.42068 128.424 5.52192 128.424 5.52192L128.423 5.53248Z",
    fill: "#000E39"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M165.766 93.041L192.052 121.214L173.311 131.556L151.909 107.594L165.766 93.041Z",
    fill: "#FFB796"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M153.572 75.5585C149.743 71.3926 138.952 69.4725 133.303 69.2816L110.329 68.125C110.329 68.125 90.7012 68.3833 84.1548 73.9416C80.2247 77.2765 73.2776 92.4025 68 106.124L92.9133 110.435C92.7786 125.078 92.9133 137.924 92.9133 137.924L93.1828 143.515L140.198 144.818L146.699 102.845L157.5 119.124L174 95.6239L153.549 75.5697L153.572 75.5585Z",
    fill: "url(#paint2_linear_7092_74372)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M160.632 135.789L170.755 84.9186C171.334 82.3172 173.554 80.4085 176.226 80.2105L240.372 75.6438C242.069 75.5166 243.37 77.1142 242.903 78.7543L228.765 129.2C228.157 131.349 226.418 132.989 224.24 133.47L132.213 153.631C131.026 153.886 129.81 153.306 129.273 152.217C128.636 150.917 129.16 149.362 130.446 148.697L160.632 135.789Z",
    fill: "#201F37"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M207.02 109.577C205.832 111.528 203.485 112.263 201.774 111.217C200.064 110.171 199.654 107.753 200.841 105.802C202.029 103.851 204.376 103.116 206.087 104.162C207.797 105.208 208.207 107.626 207.02 109.577Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M220.17 252.906L247.546 250.762L259.695 302.729L232.544 302.1L220.17 252.906Z",
    fill: "#FFB796"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M240.191 296.936C238.226 294.836 234.599 291.871 229.377 293.354L227.457 317.046L297.031 316.496C297.031 316.496 297.469 310.264 287.52 306.255C277.538 302.236 260.178 291.546 258.078 291.703C255.978 291.86 254.687 293.657 252.744 295.33C252.082 295.902 250.532 297.34 249.398 298.103C246.467 300.08 242.594 299.518 240.191 296.936Z",
    fill: "#201F37"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M269.947 297.496C267.118 298.462 264.827 300.854 263.974 303.717",
    stroke: "white",
    strokeWidth: 0.54918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M274.574 299.754C271.508 300.742 269.094 303.527 268.544 306.693",
    stroke: "white",
    strokeWidth: 0.54918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M279.256 302.27C276.191 303.258 273.777 306.031 273.227 309.209",
    stroke: "white",
    strokeWidth: 0.54918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M269.959 297.294C271.542 296.654 272.631 296.351 274.091 295.475C275.944 294.352 277.763 292.949 278.572 290.928C278.83 290.287 278.965 289.535 278.628 288.929C278.212 288.165 277.19 287.907 276.337 288.109C275.461 288.311 274.709 288.895 274.136 289.591C273.563 290.287 273.148 291.096 272.733 291.893C271.812 293.69 270.88 295.498 269.959 297.294",
    stroke: "#201F37",
    strokeWidth: 0.823771,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M270.239 297.305C268.971 296.17 268.039 295.508 266.972 294.194C265.602 292.51 264.367 290.567 264.299 288.4C264.277 287.715 264.4 286.963 264.917 286.502C265.568 285.918 266.624 286.031 267.354 286.502C268.106 286.996 268.622 287.794 268.926 288.636C269.229 289.478 269.352 290.388 269.465 291.275C269.723 293.285 269.981 295.295 270.239 297.305Z",
    stroke: "#201F37",
    strokeWidth: 0.823771,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6016 175.248L98.191 144.324L140.221 144.796L143.769 163.368L88.6016 175.248Z",
    fill: "url(#paint3_linear_7092_74372)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M246.85 204.084L270.397 189.947L304.431 231.056L279.862 242.599L246.85 204.084Z",
    fill: "#FFB796"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M284.399 234.57C281.704 233.56 277.134 232.527 273.125 236.187L281.962 258.252L344.001 226.755C344.001 226.755 341.61 220.983 330.931 221.826C320.208 222.668 299.906 220.849 298.087 221.927C296.279 223.005 295.92 225.183 294.92 227.552C294.583 228.361 293.831 230.337 293.168 231.527C291.428 234.604 287.711 235.828 284.399 234.593V234.57Z",
    fill: "#201F37"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M310.808 222.162C308.709 224.284 307.721 227.451 308.226 230.404",
    stroke: "white",
    strokeWidth: 0.54918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M315.963 222.129C313.65 224.375 312.729 227.945 313.661 231.033",
    stroke: "white",
    strokeWidth: 0.54918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M321.275 222.285C318.961 224.531 318.041 228.102 318.973 231.19",
    stroke: "white",
    strokeWidth: 0.54918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M310.764 221.702C312.347 221.062 313.436 220.759 314.896 219.883C316.749 218.76 318.568 217.357 319.376 215.336C319.634 214.696 319.769 213.943 319.432 213.337C319.017 212.573 317.995 212.315 317.142 212.517C316.266 212.719 315.513 213.303 314.941 213.999C314.368 214.696 313.953 215.504 313.537 216.301C312.616 218.098 311.684 219.906 310.764 221.702Z",
    stroke: "#201F37",
    strokeWidth: 0.823771,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M311.044 221.724C309.775 220.59 308.843 219.928 307.777 218.614C306.407 216.93 305.171 214.987 305.104 212.82C305.082 212.135 305.205 211.383 305.722 210.922C306.373 210.338 307.428 210.451 308.158 210.922C308.911 211.416 309.427 212.214 309.73 213.056C310.034 213.898 310.157 214.808 310.269 215.695C310.528 217.705 310.786 219.715 311.044 221.724Z",
    stroke: "#201F37",
    strokeWidth: 0.823771,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M288.272 207.598L233.296 136.43C233.296 136.43 220.866 120.137 201.159 127.447C181.452 134.757 90.757 168.297 90.757 168.297C90.757 168.297 88.545 171.778 86.6024 177C79.0004 197.515 96.0121 219.288 117.616 215.829C118.099 215.751 118.571 215.661 119.054 215.56L213.05 168.174L258.359 230.876L288.284 207.61L288.272 207.598Z",
    fill: "url(#paint4_linear_7092_74372)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M258.628 276.297L246.602 186.657C246.602 186.657 243.66 158.214 218.013 164.368C192.367 170.51 118.492 215.515 118.492 215.515H205.524L225.043 283.787L258.639 276.297H258.628Z",
    fill: "url(#paint5_linear_7092_74372)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M117.493 137.024L127.442 126.199C127.442 126.199 131.563 120.776 133.719 120.585C137.132 120.293 142.477 122.337 142.533 122.808C142.758 124.425 140.917 125.705 137.918 125.503L134.819 125.458L132.787 127.985C132.787 127.985 136.133 128.266 138.188 129.31C140.58 130.523 144.667 132.869 144.543 134.632C144.42 136.395 143.342 136.676 143.342 136.676C143.342 136.676 145.666 141.437 141.276 140.954C141.276 140.954 141.635 146.108 138.603 143.784C135.583 141.448 130.586 141.998 130.586 141.998C130.586 141.998 128.464 144.693 124.814 147.018C121.423 149.196 119.447 146.939 119.447 146.939L117.471 137.013L117.493 137.024Z",
    fill: "#FFB796"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M119.345 135.419L82.7279 141.965L92.2837 110.378L72.5658 106.65L62.5609 143.728C61.7974 147.097 61.8872 150.634 63.0213 153.901C64.2452 157.427 66.7156 161.077 71.7124 161.604C81.7061 162.66 122.781 147.411 122.781 147.411L119.345 135.407V135.419Z",
    fill: "#FFB796"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M127.98 130.635C128.216 129.692 128.845 128.85 129.676 128.345C130.507 127.839 131.551 127.682 132.494 127.918",
    stroke: "#FFB796",
    strokeWidth: 0.823771,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M128.98 133.836C129.969 131.601 131.327 131.411 132.125 131.231C133.281 130.984 135.078 131.759 136.122 132.309C138.806 133.712 140.984 135.161 143.342 136.834",
    stroke: "#FFB796",
    strokeWidth: 0.823771,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M128.777 138.113C128.631 136.934 129.709 135.878 130.877 135.654C132.045 135.429 133.235 135.833 134.324 136.305C136.985 137.461 139.411 139.067 141.78 140.74",
    stroke: "#FFB796",
    strokeWidth: 0.823771,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 101.623L93 110.623V129.123L97.5 101.623Z",
    fill: "url(#paint6_linear_7092_74372)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9678 293.152H74.5566V293.623H74.9678V293.152Z",
    fill: "#FFDC83"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M220 282.381H54.9043V293.153H220V282.381Z",
    fill: "#FFDC83"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6016 287.938H190.713",
    stroke: "#FFDC83",
    strokeWidth: 0.823771,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M201.17 282.756V292.586",
    stroke: "#FFDC83",
    strokeWidth: 0.823771,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M205.001 282.756V292.586",
    stroke: "#FFDC83",
    strokeWidth: 0.823771,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7441 282.756V292.586",
    stroke: "#FFDC83",
    strokeWidth: 0.823771,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5752 282.756V292.586",
    stroke: "#FFDC83",
    strokeWidth: 0.823771,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M214.627 287.809C214.627 289.159 213.664 290.262 212.487 290.262C211.309 290.262 210.347 289.159 210.347 287.809C210.347 286.46 211.309 285.357 212.487 285.357C213.664 285.357 214.627 286.46 214.627 287.809Z",
    fill: "#FFDC83"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M210.305 256.777H35.278C34.6714 256.777 34.1797 257.269 34.1797 257.876V281.293C34.1797 281.899 34.6714 282.391 35.278 282.391H210.305C210.911 282.391 211.403 281.899 211.403 281.293V257.876C211.403 257.269 210.911 256.777 210.305 256.777Z",
    fill: "#FFD15C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M172.596 265.299H81.0466C80.44 265.299 79.9482 265.791 79.9482 266.397V273.34C79.9482 273.947 80.44 274.439 81.0466 274.439H172.596C173.203 274.439 173.694 273.947 173.694 273.34V266.397C173.694 265.791 173.203 265.299 172.596 265.299Z",
    fill: "#FFD15C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M199.376 214.521H64.0928V257.149H199.376V214.521Z",
    fill: "#FFFCF0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M199.376 214.395H60.3623V219.833H199.376V214.395Z",
    fill: "#FFDC83"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M199.376 251.014H60.3623V257.748H199.376V251.014Z",
    fill: "#FFDC83"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M199.779 214.395H189.726V257.876H199.779V214.395Z",
    fill: "#FFDC83"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5234 227.156H179.163",
    stroke: "#F6E3AF",
    strokeWidth: 0.54918
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5234 232.648H179.163",
    stroke: "#F6E3AF",
    strokeWidth: 0.54918
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5234 238.141H179.163",
    stroke: "#F6E3AF",
    strokeWidth: 0.54918
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5234 243.631H179.163",
    stroke: "#F6E3AF",
    strokeWidth: 0.54918
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5078 227.531V266.398L104.669 256.237L115.409 266.977V227.531H94.5078Z",
    fill: "#8A90EC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M133.384 44.3095C132.556 44.6848 129.625 44.681 128.767 42.3313",
    stroke: "#A15842",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M127.196 32.9301C126.43 32.8311 125.889 32.1299 125.989 31.364C126.088 30.5981 126.789 30.0575 127.555 30.1566C128.321 30.2556 128.861 30.9568 128.762 31.7227C128.663 32.4886 127.962 33.0292 127.196 32.9301Z",
    fill: "#30242A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M138.928 32.5786C138.162 32.4795 137.622 31.7783 137.721 31.0124C137.82 30.2466 138.521 29.706 139.287 29.805C140.053 29.9041 140.594 30.6053 140.494 31.3711C140.395 32.137 139.694 32.6776 138.928 32.5786Z",
    fill: "#30242A"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M134.511 36.043C134.674 36.9505 134.79 37.9303 134.591 38.2261C134.322 38.5988 133.95 38.8845 133.52 39.0481",
    stroke: "#A15842",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M135.456 31.512C135.174 27.0838 138.177 23.2884 142.164 23.0348C146.15 22.7811 149.61 26.1652 149.892 30.5934C150.174 35.0216 147.171 38.817 143.184 39.0706C139.198 39.3243 135.738 35.9401 135.456 31.512Z",
    stroke: "#30242A",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M117.558 31.3948C117.277 26.9666 120.28 23.1712 124.266 22.9176C128.253 22.6639 131.713 26.048 131.995 30.4762C132.276 34.9044 129.273 38.6998 125.287 38.9534C121.3 39.2071 117.84 35.823 117.558 31.3948Z",
    stroke: "#30242A",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M135.207 30.8164L132.366 30.7541",
    stroke: "#30242A",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7092_74372",
    x1: 332.385,
    y1: 155.664,
    x2: 247.262,
    y2: 299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27AE60",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19984E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7092_74372",
    x1: 41.5958,
    y1: 198.273,
    x2: 92.8731,
    y2: 306.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27AE60",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19984E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7092_74372",
    x1: 118.027,
    y1: 68.125,
    x2: 118.027,
    y2: 144.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE8AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7092_74372",
    x1: 116.185,
    y1: 144.324,
    x2: 116.185,
    y2: 175.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6068DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7092_74372",
    x1: 186.522,
    y1: 125.561,
    x2: 186.522,
    y2: 230.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6068DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7092_74372",
    x1: 188.566,
    y1: 163.496,
    x2: 188.566,
    y2: 283.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6068DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7092_74372",
    x1: 95.25,
    y1: 101.623,
    x2: 95.25,
    y2: 129.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFBD3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD15C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBanner);
export default __webpack_public_path__ + "static/media/loginBanner.045367a0ca95ff5645bbfd848ae09670.svg";
export { ForwardRef as ReactComponent };